// utils/api/index.js

// Import all dependencies first
import { userApi } from './UserApi';
import { classApi } from './ClassApi';
import { documentEditorApi } from './DocumentEditorApi';

// Export utility functions
export { apiCall, getAuthHeaders } from './ApiUtils';

// Export domain-specific APIs
export { userApi, classApi, documentEditorApi };

// Combined API object for backward compatibility
export const api = {
  ...userApi,
  ...classApi,
  ...documentEditorApi,
};